/** Preferiti esperienze: localStorage + evento per sincronizzare navbar e card. */
const KEY = "tv_favorites";

export const getFavorites = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export const toggleFavorite = (item) => {
    const favs = getFavorites();
    const exists = favs.some((f) => f.id === item.id);
    const next = exists ? favs.filter((f) => f.id !== item.id) : [...favs, item];
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("tv:favorites"));
    return !exists;
};

export const subscribeFavorites = (cb) => {
    const handler = () => cb(getFavorites());
    window.addEventListener("tv:favorites", handler);
    return () => window.removeEventListener("tv:favorites", handler);
};
